import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface Position extends BaseEntity {
  readonly description: string;
}

export type PositionCollection = RxCollection<Position> | null;
export type PositionDocument = RxDocument<Position>;

export const positionSchema: RxJsonSchema<Position> = {
  type: 'object',
  version: 0,
  description: 'describes a position object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
  },
};

export const positionPullQueryBuilder = (doc: any) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }
  const query = print(gql`{
      positionFeed (siteId: "${rootStore.user.siteId}", lastUpdateAt: ${doc.updatedAt}, limit: ${SYNC_LIMIT_LOW}){
        id
        description
        isDeleted
        updatedAt
        version
      }
    }`);
  return {
    query,
    variables: {},
  };
};

export default {};
